export enum AppealState {
  Referred = "Referred",
  ReferralInProgress = "Referral in progress",
  InProgress = "In Progress",
  InSupport = "In Support",
  Submitted = "Submitted",
  NotApproved = "Not Approved",
  Approved = "Approved",
  Expired = "Expired",
}

export const AVAILABLE_APPEAL_STATES = [
  AppealState.ReferralInProgress,
  AppealState.Referred,
  AppealState.InProgress,
  AppealState.InSupport,
  AppealState.Submitted,
  AppealState.NotApproved,
  AppealState.Approved,
  AppealState.Expired,
];

export type AppealStatus = {
  referred?: boolean | null;
  insuranceCardUpload?: boolean | null;
  insuranceCardUploadSkipped?: boolean | null;
  paymentSuccessful?: boolean | null;
  issueOutstanding?: boolean | null;
  denialUpheld?: boolean | null;
  denialOverturned?: boolean | null;
  appealSubmitted?: boolean | null;
};

export function getAppealStateFromAppealStatus(
  status: AppealStatus,
  isExpired: boolean,
): AppealState {
  if (isExpired) {
    return AppealState.Expired;
  }

  if (!status.referred) {
    return AppealState.ReferralInProgress;
  }

  if (status.denialOverturned) {
    return AppealState.Approved;
  }

  if (status.denialUpheld) {
    return AppealState.NotApproved;
  }

  if (status.paymentSuccessful) {
    return AppealState.Submitted;
  }

  if (status.issueOutstanding) {
    return AppealState.InSupport;
  }

  if (
    status.referred &&
    (status.insuranceCardUpload || status.insuranceCardUploadSkipped) &&
    !status.appealSubmitted &&
    !status.issueOutstanding
  ) {
    return AppealState.InProgress;
  }

  return AppealState.Referred;
}
